/**
 * Mockup v3 P4 (Mockups): the strings of duplicate, transfer, export, people with access and the
 * version note. Spread into `es` by `es.ts`; P4 adds its keys here only. The scaffold put the two
 * tabs of the share popover here, since P4 owns the people tab.
 */
export const esMockupsAccess = {
  "sharing.tab.label": "Compartir con",
  "sharing.tab.link": "Enlace",
  "sharing.tab.people": "Personas con acceso",
  // F2 card menu, duplicate, export and transfer (v3 :2810-2865; toast per default P4-2).
  "mockups.menu.duplicate": "Duplicar",
  "mockups.menu.transfer": "Transferir propiedad…",
  "mockups.menu.exportGroup": "Exportar",
  "mockups.menu.exportHtml": "HTML de la versión actual",
  "mockups.menu.exportZip": "Paquete ZIP",
  "mockups.menu.exportDiagram": "Diagrama (ZIP)",
  "mockups.duplicate.done": "Se creó «{name}» con su versión actual",
  "mockups.duplicate.doneEmpty": "Se creó «{name}»",
  "mockups.duplicate.open": "Abrir",
  "mockups.duplicate.failed": "No se pudo duplicar el mockup.",
  "mockups.export.noVersion": "Este mockup aún no tiene versiones.",
  "mockups.export.failed": "No se pudo descargar el archivo.",
  "mockups.transfer.title": "Transferir la propiedad",
  "mockups.transfer.intro": "«{name}» pasará a ser de otra persona de la organización. Será quien decida quién más tiene acceso.",
  "mockups.transfer.who": "Nueva propietaria o propietario",
  "mockups.transfer.notice": "Seguirás con acceso para editar. Los enlaces compartidos siguen funcionando.",
  "mockups.transfer.noticeOther": "{name} seguirá con acceso para editar. Los enlaces compartidos siguen funcionando.",
  "mockups.transfer.submit": "Transferir",
  "mockups.transfer.done": "«{name}» ahora es de {person}",
  "mockups.transfer.failed": "No se pudo transferir el mockup.",
  "mockups.transfer.personal": "Un mockup personal no se transfiere: muévelo antes a un equipo o a la organización.",
  "mockups.transfer.nobody": "No hay otra persona en la organización a quien transferirlo.",
  "mockups.transfer.loading": "Cargando las personas de la organización…",
  "mockups.transfer.peopleFailed": "No se pudieron cargar las personas de la organización.",
  // F3 the editor's "Más acciones" (v3 :2221).
  "mockups.more.label": "Más acciones",
  "mockups.more.trashTitle": "¿Mover «{name}» a la papelera?",
  "mockups.more.trashBody": "Se podrá restaurar desde la papelera hasta que se borre definitivamente.",
  // F4 the share popover tab "Personas con acceso" (v3 :1651-1656; personal mockup per default P4-5).
  "sharing.tab.peopleCount": "Personas con acceso {count}",
  "sharing.people.help": "Personas de tu organización que pueden abrir este mockup en la app. Para quien no tiene cuenta, usa un enlace.",
  "sharing.people.list": "Personas con acceso",
  "sharing.people.owner": "Propietario",
  "sharing.people.roleOf": "Rol de {name}",
  "sharing.people.role.editor": "Editor",
  "sharing.people.role.viewer": "Lector",
  "sharing.people.remove": "Quitar el acceso de {name}",
  "sharing.people.addWho": "Persona que añadir",
  "sharing.people.addRole": "Rol",
  "sharing.people.add": "Añadir",
  "sharing.people.allIn": "Todas las personas de la organización ya tienen acceso.",
  "sharing.people.roles": "Editor: conversa y crea versiones. Lector: solo mira.",
  "sharing.people.transferLead": "Para cambiar el propietario usa",
  "sharing.people.transfer": "Transferir propiedad",
  "sharing.people.personal": "Solo tú tienes acceso.",
  "sharing.people.personalOther": "Solo la persona propietaria tiene acceso.",
  "sharing.people.you": "Tú",
  "sharing.people.unknown": "Persona sin acceso a la organización",
  "sharing.people.loading": "Cargando las personas con acceso…",
  "sharing.people.failed": "No se pudieron cargar las personas con acceso.",
  "sharing.people.changeFailed": "No se pudo cambiar el acceso.",
  // F5 the version timeline: note, help and the two ways back (v3 :2600-2610).
  "versions.help.useLead": "Usar esta versión",
  "versions.help.useRest": "cambia cuál es la actual; no crea mensajes.",
  "versions.help.continueLead": "Continuar desde aquí",
  "versions.help.continueRest": "abre una rama de la conversación desde esa versión.",
  "versions.row.continue": "Continuar desde aquí",
  "versions.row.continueOf": "Continuar desde aquí (v{n})",
  "versions.note.add": "Añadir nota",
  "versions.note.editOf": "Editar la nota de la v{n}",
  "versions.note.labelOf": "Nota de la v{n}",
  "versions.note.placeholder": "Por ejemplo: la que vio el cliente",
  "versions.note.save": "Guardar",
  "versions.note.failed": "No se pudo guardar la nota.",
} as const;
